import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {TeammateModel} from '../../../../models/api/teammateModel';
import {AppState} from '../../../../store/appState';
import {makeGetOnlineStatus} from '../../../../store/data/teammates/onlineTeammatesSelectors';
import {MentionDropdownItem} from '../../dropdowns/autocomplete/mentionDropdownItem';

/*
 * Props.
 */

interface MentionEditorDropdownTeammateItemContainerProps {
  teammate: TeammateModel;
}

/*
 * Selectors.
 */

function getTeammateId(_state: AppState, props: MentionEditorDropdownTeammateItemContainerProps) {
  return props.teammate.id;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<MentionEditorDropdownTeammateItemContainerProps>()(() => ({
  onlineStatus: makeGetOnlineStatus(getTeammateId),
}));

export const MentionEditorDropdownTeammateItemContainer = connect(mapStateToProps)(MentionDropdownItem);
